import React from 'react';
import FrontendSkill from './FrontendSkill';
import BackendSkill from './BackendSkill';
import MoreSkill from './MoreSkill';
import WebSkill from './WebSkill';

const categories = [
   {
      id: 'skillsSection',
      title: 'Android & Mobile Development',
      tag: '/core stack',
      accent: 'from-brand-500 to-emerald-400',
      dot: 'bg-brand-500',
      component: <FrontendSkill />,
   },
   {
      id: 'backendSkillsSection',
      title: 'App Security & Backend',
      tag: '/hardening',
      accent: 'from-orange-500 to-red-500',
      dot: 'bg-orange-500',
      component: <BackendSkill />,
   },
   {
      id: 'webSkillsSection',
      title: 'Web Development',
      tag: '/web stack',
      accent: 'from-sky-500 to-blue-600',
      dot: 'bg-sky-500',
      component: <WebSkill />,
   },
   {
      id: 'otherToolsSection',
      title: 'Tools & Workflow',
      tag: '/daily-driver',
      accent: 'from-violet-500 to-purple-600',
      dot: 'bg-violet-500',
      component: <MoreSkill />,
   },
];

const SkillSection = () => (
   <div className="flex flex-col gap-5">
      {categories.map(({ id, title, tag, accent, dot, component }) => (
         <div key={id} className="glass-card overflow-hidden">
            {/* Colored gradient top bar */}
            <div className={`h-[3px] w-full bg-gradient-to-r ${accent}`} />

            <div className="p-4 pt-3.5">
               {/* Section header */}
               <div className="flex items-center justify-between gap-2 mb-4">
                  <div className="flex items-center gap-2">
                     <span className={`h-2 w-2 rounded-full shrink-0 ${dot}`} />
                     <h3 className="font-display text-[13px] font-bold tracking-tight text-zinc-800 dark:text-zinc-100">
                        {title}
                     </h3>
                  </div>
                  <span className="text-[10px] font-mono text-zinc-400 dark:text-zinc-500 shrink-0">{tag}</span>
               </div>

               {/* Skill grid */}
               <div className="grid grid-cols-3 sm:grid-cols-4 gap-2.5" id={id}>
                  {component}
               </div>
            </div>
         </div>
      ))}
   </div>
);

export default SkillSection;
